<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Pilih Item
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Nama Kategori" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Item
                    </div>

                    <v-autocomplete
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
  
                      :color="set_color"
                      placeholder="Pilih salah satu bila diperlukan"
  
                      hide-details
                      clearable
                      item-text="name"
                      item-value="id"
                      :items="item"
                      multiple
                      return-object
  
                      v-model="selected"
                      class="mb-6"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="selected !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="saveItem()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/pembelian/pengadaan"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Tambah Pengadaan
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col>
                          <div class="d-flex px-2" style="width: 100%;">
                            <div class="fs-18 font-weight-bold black_one">
                              Data Item
                            </div>
  
                            <div class="ml-auto">
                              <v-btn
                                elevation="0"
                                @click="dialog.form = true; reset();"
                                color="#240087"
                                class="fs-12 white--text text-capitalize border-radius">
                                <v-icon
                                  size="20">
                                  mdi-plus
                                </v-icon>
  
                                <span
                                  class="ml-2">
                                  Tambah Item
                                </span>
                              </v-btn>
                            </div>
                          </div>

                          <v-card flat
                            v-if="form.items.length < 1">
                            <v-card-text
                              class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <v-img 
                                  class="mx-auto"
                                  contain
                                  alt="vuetify"
                                  :width="90"
                                  :height="90"
                                  :src="require('@/assets/image/empty.png')">
                                  <!-- <template v-slot:placeholder>
                                    <v-row
                                      class=" "
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template> -->
                                </v-img>
                                <div class="mt-3 fs-18">
                                  Belum Ada Item
                                </div>
                              </div>
                            </v-card-text>
                          </v-card>

                          <div class="mt-5" v-if="form.items.length > 0">
                            <div v-for="(item, index) in form.items" :key="index">
                              <v-card flat class="mb-5" style="    background: #f0f8ff80; border-radius: 10px; border: 1px solid #f1f1f1;">
                                <v-card-text>
                                  <div class="d-flex">
                                    <div>
                                      <div class="fs-16 font-weight-bold black_one">
                                        {{ item.name }}
                                      </div>
                                      <div>
                                        Kategori: <span class="font_weight_600">{{ item.category_item_name }}</span>
                                      </div>
                                      <div>
                                        Harga Beli: <span class="font_weight_600">{{ item.purchase_price | price }} / {{ item.satuan }}</span>
                                      </div>
                                      <v-img 
                                        v-if="item.image_url !== ''"
                                        class="mr-auto mt-2"
                                        contain
                                        alt="vuetify"
                                        :width="50"
                                        :height="50"
                                        :src="item.image_url">
                                        <!-- <template v-slot:placeholder>
                                          <v-row
                                            class=" "
                                            align="center"
                                            justify="center">
                                            <v-progress-circular 
                                              indeterminate 
                                              :color="set_color">
                                            </v-progress-circular>
                                          </v-row>
                                        </template> -->
                                      </v-img>
                                    </div>

                                    <div class="ml-auto text-right">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          
                                            @click="form.items.splice(index, 1); changeTotal()"

                                            v-bind="attrs"
                                            v-on="on"

                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0 mb-2"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
                                        
                                        <span>Hapus</span>
                                      </v-tooltip>

                                      
                                    </div>
                                    
                                  </div>

                                  <v-row class="mt-4">
                                    <v-col cols="4">
                                      <div>
                                        Harga Beli
                                      </div>
                                    </v-col>
                                    <v-col cols="4">
                                      <div>
                                        Quantity
                                      </div>
                                    </v-col>
                                    <v-col cols="4" class="text-right">
                                      <div>
                                        Total
                                      </div>
                                    </v-col>

                                    <v-col class="py-0" cols="4">
                                      <div class="fs-16 font_weight_600 black_one">
                                        {{ item.purchase_price | price }} / {{ item.satuan }}
                                      </div>
                                    </v-col>
                                    <v-col class="py-0" cols="4">
                                      <div>
                                        <ValidationProvider
                                          :name="`Quantity ${item.name}`" 
                                          :rules="`min_value:0`" 
                                          v-slot="{ errors }">
                                          <v-currency-field
                                                
                                            
                                            rounded
                                            dense
                                            outlined
                                            hide-details
                      
                                            color="#718EBF"
                                            placeholder="Qty"
                                            v-on:change="changeTotal()"
                                            :error-messages="errors"

                                            
                      
                                            v-model="item.qty"
                                            
                                            required
                                            style="border-radius: 10px;">
                                            <template v-slot:append-outer>
                                              <div v-if="errors.length > 0">
                                                <v-tooltip top color="#ff5252">
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                  </template>
                                                  
                                                  {{ errors[0] }}
                                                </v-tooltip>
                                              </div>
                                              
                                              <div v-if="item.qty !== '' && valid">
                                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                                              </div>
                                            </template>
                                          </v-currency-field>
                                        </ValidationProvider>
                                      </div>
                                    </v-col>
                                    <v-col cols="4" class="py-0 text-right">
                                      <div class="fs-16 font_weight_600 black_one">
                                        {{ (item.qty*1) * (item.purchase_price*1) | price }}
                                      </div>
                                    </v-col>

                                    <v-col class="py-0" cols="4">
                                      <ValidationProvider 
                                        :name="`Bagian ${item.name}`"
                                        rules="required" 
                                        v-slot="{ errors, valid }">
                                        <div class="mb-2">
                                          <span class="red--text">*</span>
                                          Bagian {{ item.name }}
                                        </div>
                                        <v-autocomplete
                                          v-on:keyup.enter="save()"
                                          
                                          outlined
                                          rounded
                                          dense
                                          :color="set_color"
                                          placeholder="Pilih salah satu Bagian"
                                          hide-details
                                          clearable
                                          item-text="name"
                                          item-value="id"
                                          :items="item.lokasi"
                                          v-model="item.location_id"
                                          class="mb-6"
                                          :error-messages="errors"
                                          required
                                          style="border-radius: 10px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
  
                                            <div v-if="item.location_id !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div>
                                          </template>
                                        </v-autocomplete>
                                      </ValidationProvider>
                                    </v-col>

                                    <v-col class="py-0" cols="12">
                                      <div class="mb-2">
                                        Catatan
                                      </div>
                                      <v-textarea
                                        v-model="item.note_permintaan"
                                        outlined
                                        dense
                                        rows="2"
                                        placeholder="Catatan"
                                        style="border-radius: 10px;">
                                      </v-textarea>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </div>
                            <v-divider class="my-2"></v-divider>
                            <v-row>
                              <v-col>
                                <div class="fs-17 font_weight_600 text-left black_one">
                                  Total Perkiraan Modal Belanja
                                </div>
                              </v-col>
                              <v-col>
                                <div class="fs-17 font_weight_600 text-right black_one">
                                  {{ total_nominal | price }}
                                </div>
                              </v-col>
                            </v-row>
                          </div>

                        </v-col>
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                elevation="0"
                color="#240087"
                class="body-2 white--text text-capitalize border-radius">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              <v-btn
                @click="$router.go(-1)"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        item: [],

        dialog: {
          form: false,
          fullscreen: false
        
        },
        total_nominal: 0,
        supplier: [],

        form: {
          outlet_id: '',
          supplier_id: '',

          date: '',
          status: 'Menunggu',
          items: []

        },
        selected: [],
        menu2: false,
        location: [],
        show: false,
        upload: {
          image: null
        },

        process: {
          form: false,

          image: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      // this.fetchBagian()
      this.location = [
        {
          desc: "Alamat Dapur",
          id: "3",
          latitude: "-6.1810834892726",
          longitude: "106.83024328528",
          name: "Dapur"
        },
        {
          desc: "Alamat Gudang",
          id: "2",
          latitude: "-6.1810834892726",
          longitude: "106.83024328528",
          name: "Gudang"
        }
      ]
      this.item = [
        {
          id: "16",
          par_id: "0",
          category_item_id: "3",
          category_item_name: "Makanan",
          name: "Ayam",
          name: "Ayam",
          satuan: "pcs",
          image_url: "https:\/\/cdn.amanata.co\/2024\/04\/image\/amanata-icon+1-1713978891.png",
          desc: "",
          note: "Contoh Item",
          purchase_price: "50000",
          qty: 0,
          note_permintaan: '',
          total: 0,
          location_id: '',
          lokasi: this.location
      },
      {
          id: "17",
          par_id: "0",
          category_item_id: "4",
          category_item_name: "Nasi",
          name: "Daging",
          name: "Daging",
          satuan: "pcs",
          image_url: "https:\/\/cdn.amanata.co\/2024\/04\/image\/Frame+33848-1713978920.png",
          desc: "",
          note: "Harga daging",
          purchase_price: "300000",
          qty: 0,
          note_permintaan: '',
          total: 0,
          location_id: '',
          lokasi: this.location
      },
      ]
      this.form.outlet_id = this.user.cat_title === 'Owner' ? this.outlet.outlet_id : this.outlet.outlet_id
    },
    methods: {
      async fetch () {
        let params = {
          limit: 100000,
          outlet_id: this.outlet.outlet_id
        }
        
        await get('pos/pembelian/item/data_last_child', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.item = []
            res.results.data.map((item) => {
              this.item.push({ 
                ...item,
                qty: 0,
                note_permintaan: '',
                total: 0,
                location_id: '',
                lokasi: this.location
              })
            })
            // this.item.map((item) => {
            //   this.fetchSupplier(item.id)
            // })
            // this.item = res.results.data
          }
        })
      },
      async fetchSupplier () {
        let params = {
          limit: 100000
        }
        
        await get('pos/pembelian/item_supplier/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.supplier = res.results.data
          }
        })
      },
      changeTotal() {
        this.total_nominal = this.form.items.reduce((acc, item) => {
          return acc + (item.qty * item.purchase_price)
        }, 0)
      },

      async fetchBagian () {
        let params = {
          limit: 100000
        }
        
        await get('pos/location/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.location = res.results.data
            this.fetch()
          }
        })
      },
      reset () {
        this.selected = this.form.items
      },
      saveItem () {
        this.form.items = this.selected
        this.dialog.form = false
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          // await post(`pos/pembelian/request/add`, {
          //   data: {
          //     ...this.form,
          //     items: JSON.stringify(this.form.items.map(item => {
          //     return {
          //       item_id: item.id,
          //       qty: item.qty,
          //       note: item.note_permintaan,
          //       supplier_id: item.supplier_id
          //     }
          //   }))
          //   }
          // })
          // .then((response) => {
          //   let res = response.data

          //   this.process.form = false

          //   if (res.status === 200) {

              this.$router.push({ path: `/pembelian/pengadaan/detail/${this.$route.params.id}` })

            // } else {
            //   this.message.error = res.message
            // }
          // })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>